import { Rutas } from '@/constants/rutas';
import RuletaFantasyIcon from '../../icons/RuletaFantasyIcon';

export const NavigationRuletaFantasyItems = [
    {
        title: 'Jugar a la Ruleta',
        shortTitle: 'Ruleta',
        path: Rutas.RULETA_FANTASY,
        icon: <RuletaFantasyIcon size={20} />,
        id: 'ruleta-fantasy',
    },
    {
        title: 'Ranking por aciertos',
        shortTitle: 'Ranking por aciertos',
        path: Rutas.RULETA_FANTASY_RANKING,
    },
    {
        title: 'Ranking Global',
        shortTitle: 'Ranking Global',
        path: Rutas.RULETA_FANTASY_RANKING_GLOBAL,
    },
];
